import "core-js/modules/es.string.fixed.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "cropper",
    attrs: {
      visible: _vm.visible,
      title: _vm.$t("public.pleaseCropThePicture"),
      maskClosable: false,
      confirmLoading: _vm.confirmLoading,
      cancelText: _vm.$t("public.cancel"),
      okText: _vm.$t("public.confirm")
    },
    on: {
      cancel: _vm.handleCancel,
      ok: _vm.handleOk
    }
  }, [_c("div", {
    staticClass: "cropper-wrapper"
  }, [_c("vue-cropper", {
    ref: "cropper",
    attrs: {
      img: _vm.img,
      info: true,
      original: true,
      full: false,
      autoCrop: _vm.options.autoCrop,
      autoCropWidth: _vm.options.autoCropWidth,
      autoCropHeight: _vm.options.autoCropHeight,
      fixed: _vm.options.fixed,
      fixedNumber: _vm.options.fixedNumber,
      outputType: _vm.options.outputType,
      maxImgSize: 8000,
      fixedBox: _vm.options.fixedBox,
      enlarge: _vm.options.enlarge,
      infoTrue: _vm.options.infoTrue,
      centerBox: _vm.options.centerBox
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };